
import firebase from "firebase"


firebase.initializeApp({
    apiKey: "AIzaSyCBnyZuB-rGnSWzYX354J-kdcc5768OtQM",
    authDomain: "sartex-2ae64.firebaseapp.com",
    databaseURL: "https://sartex-2ae64.firebaseio.com",
    projectId: "sartex-2ae64",
    storageBucket: "sartex-2ae64.appspot.com",
    messagingSenderId: "641621189530",
    appId: "1:641621189530:web:587d299b186ee3b9bd5023"
})
let db = firebase.database()

export let auth = firebase.auth()



export default db